import { useReducedMotion } from "framer-motion";
import { healthChildPageHeroAmbientWrap } from "./healthVisualStyles";
import "./healthChildPageHeroAmbient.css";

/** Clipped circular blurs for Aimma child-page heroes — Health / Aiia-style ambient, no orbit. */
export function HealthChildPageHeroAmbient() {
    const reducedMotion = useReducedMotion();

    return (
        <div className={healthChildPageHeroAmbientWrap} aria-hidden="true">
            <div
                className={`health-child-hero-blob health-child-hero-blob--a${
                    reducedMotion ? " health-child-hero-blob--static" : ""
                }`}
            />
            <div
                className={`health-child-hero-blob health-child-hero-blob--b${
                    reducedMotion ? " health-child-hero-blob--static" : ""
                }`}
            />
            <div
                className={`health-child-hero-blob health-child-hero-blob--c${
                    reducedMotion ? " health-child-hero-blob--static" : ""
                }`}
            />
        </div>
    );
}
